export default __webpack_public_path__ + "static/ll_banner_newsletter_desktop-72246354093423c41e91e4e8fe1de957.jpg";